'use client'

import { LuLoaderCircle } from 'react-icons/lu'

export default function Spinner() {
  return (
    <span
      role="status"
      aria-label="불러오는 중"
      className="inline-flex size-5 items-center justify-center text-point"
    >
      <LuLoaderCircle aria-hidden="true" className="size-5 animate-spin" />
    </span>
  )
}
